import FilesSourcingSnippet from 'content/snippets/main/gatsby-files-sourcing';
import GraphQLAllPostsSnippet from 'content/snippets/main/graphql-mdx-posts';
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  FilesSourcingSnippet,
  GraphQLAllPostsSnippet,
  React,
  MDXTag
};